var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLedBrightness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LED_Brightness",
    "data-name": "LED Brightness",
    transform: "translate(-907 -573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2907",
    "data-name": "Group 2907",
    transform: "translate(907 573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "brightness-weather-svgrepo-com"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(0 0)",
    fill: "#f68f28"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2903",
    "data-name": "Group 2903",
    transform: "translate(15.656 15.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6444",
    "data-name": "Path 6444",
    d: "M141.687,107.116,137.23,112.1,125.283,99.955l-.406,6.225-2.213,2.281,9.131,9.131-17.438,11.72-5.776-5.777L99.63,125.5l11.045,11.045L106.42,141.8l22.047,22.047a39.868,39.868,0,0,0,35.082-34.873Z",
    transform: "translate(-99.63 -99.955)",
    fill: "#d18233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6445",
    "data-name": "Path 6445",
    d: "M164.983,161.763l11.678,11.678.613,1.087,3.565-2.223-14.283-14.283",
    transform: "translate(-154.809 -148.982)",
    fill: "#d18233"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 12.15,
    cy: 12.15,
    r: 12.15,
    transform: "translate(27.85 27.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6446",
    "data-name": "Path 6446",
    d: "M361.672,247.69h-5.814a1.879,1.879,0,0,1,0-3.757h5.814a1.879,1.879,0,0,1,0,3.757Z",
    transform: "translate(-298.725 -205.812)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2904",
    "data-name": "Group 2904",
    transform: "translate(15.175 15.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6447",
    "data-name": "Path 6447",
    d: "M104.232,247.69H98.418a1.879,1.879,0,0,1,0-3.757h5.814a1.879,1.879,0,1,1,0,3.757Z",
    transform: "translate(-96.539 -220.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6448",
    "data-name": "Path 6448",
    d: "M245.812,363.551a1.879,1.879,0,0,1-1.879-1.879v-5.814a1.879,1.879,0,1,1,3.757,0v5.814A1.879,1.879,0,0,1,245.812,363.551Z",
    transform: "translate(-220.986 -313.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6449",
    "data-name": "Path 6449",
    d: "M245.812,106.112a1.879,1.879,0,0,1-1.879-1.879V98.419a1.879,1.879,0,1,1,3.757,0v5.814A1.879,1.879,0,0,1,245.812,106.112Z",
    transform: "translate(-220.986 -96.54)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2905",
    "data-name": "Group 2905",
    transform: "translate(40.045 15.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6450",
    "data-name": "Path 6450",
    d: "M268.392,190.123a12.148,12.148,0,0,0-12.1-12.147V202.27A12.148,12.148,0,0,0,268.392,190.123Z",
    transform: "translate(-256.288 -165.3)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6451",
    "data-name": "Path 6451",
    d: "M256.288,353.992v9.567a1.878,1.878,0,0,0,1.834-1.877v-5.814A1.878,1.878,0,0,0,256.288,353.992Z",
    transform: "translate(-256.288 -313.913)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6452",
    "data-name": "Path 6452",
    d: "M256.288,96.553v9.567a1.878,1.878,0,0,0,1.834-1.877V98.429A1.878,1.878,0,0,0,256.288,96.553Z",
    transform: "translate(-256.288 -96.553)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6453",
    "data-name": "Path 6453",
    d: "M327.737,329.617a1.873,1.873,0,0,1-1.328-.55l-4.112-4.111a1.879,1.879,0,1,1,2.656-2.657l4.112,4.111a1.879,1.879,0,0,1-1.328,3.207Z",
    transform: "translate(-311.556 -286.69)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2906",
    "data-name": "Group 2906",
    transform: "translate(21.896 21.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6454",
    "data-name": "Path 6454",
    d: "M145.7,147.581a1.872,1.872,0,0,1-1.328-.55l-4.111-4.112a1.879,1.879,0,0,1,2.657-2.656l4.111,4.112a1.879,1.879,0,0,1-1.329,3.207Z",
    transform: "translate(-139.711 -139.713)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6455",
    "data-name": "Path 6455",
    d: "M141.588,329.616a1.879,1.879,0,0,1-1.328-3.207l4.112-4.112a1.879,1.879,0,1,1,2.657,2.657l-4.112,4.112A1.874,1.874,0,0,1,141.588,329.616Z",
    transform: "translate(-139.71 -293.408)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6456",
    "data-name": "Path 6456",
    d: "M323.626,147.579a1.879,1.879,0,0,1-1.328-3.207l4.112-4.112a1.879,1.879,0,1,1,2.657,2.657l-4.112,4.112A1.874,1.874,0,0,1,323.626,147.579Z",
    transform: "translate(-271.512 -117.815)",
    fill: "#f5f5f5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedBrightness);
export default __webpack_public_path__ + "static/media/LedBrightness.f5312b4a1c38c8cc1153bb043e26a891.svg";
export { ForwardRef as ReactComponent };